export default "__VITE_ASSET__KTGNe2gB__"